import { render } from "./BenchmarkParameters.vue?vue&type=template&id=1ec8ea38&scoped=true"
import script from "./BenchmarkParameters.vue?vue&type=script&lang=js"
export * from "./BenchmarkParameters.vue?vue&type=script&lang=js"

import "./BenchmarkParameters.vue?vue&type=style&index=0&id=1ec8ea38&scoped=true&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec8ea38"]])

export default __exports__